<template>
  <div class="contact-data payment-view split-view fill-height">
    <v-row class="split-view__row fill-height" no-gutters>
      <left-side-image />
      <v-col cols="12" md="7" class="split-view__panel">
        <div class="split-view__scroll">
        <nav-bar-page />
        <v-container>
          <v-row justify="center" class="mt-0">
            <v-col cols="12" class="mt-0 py-0">
              <v-stepper alt-labels elevation="0">
                <v-stepper-header>
                  <v-stepper-step step="" class="active-step today-medium">
                    Póliza
                  </v-stepper-step>

                  <v-divider inset class="active-separator-step"></v-divider>

                  <v-stepper-step step="" class="active-step today-medium">
                    Simulador
                  </v-stepper-step>

                  <v-divider class="active-separator-step"></v-divider>

                  <v-stepper-step step="" class="active-step today-medium">
                    Formulario
                  </v-stepper-step>

                  <v-divider class="active-separator-step"></v-divider>

                  <v-stepper-step step="" class="active-step today-medium">
                    Firma de documentos
                  </v-stepper-step>

                  <v-divider class="active-separator-step"></v-divider>

                  <v-stepper-step step="" class="active-step today-medium">
                    Pago
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
            <v-col class="text-center justify-center d-flex d-sm-none">
              <div class="text-h6 today-medium primary--text">Pago</div>
            </v-col>
          </v-row>
          <template v-if="pageLoading">
            <div class="d-flex justify-center mt-6">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
                aria-label="Cargando información de pago"
              ></v-progress-circular>
            </div>
          </template>
          <template v-else>
            <v-row justify="center">
              <v-col cols="12" md="10" class="px-4">
                <section class="payment-section">
                  <h2 class="payment-section__title today-medium">
                    Información de la póliza
                  </h2>
                  <dl class="payment-list">
                    <div class="payment-list__row">
                      <dt>Aseguradora</dt>
                      <dd>{{ insurer_name }}</dd>
                    </div>
                    <div class="payment-list__row">
                      <dt>Fecha de vigencia</dt>
                      <dd>
                        {{ formatDateCo(valid.from) }} –
                        {{ formatDateCo(valid.to) }}
                      </dd>
                    </div>
                    <div class="payment-list__row">
                      <dt>Valor de la póliza</dt>
                      <dd class="payment-list__value">
                        {{ formatCurrency(valueFinance) }}
                      </dd>
                    </div>
                  </dl>
                </section>

                <section class="payment-section">
                  <h2 class="payment-section__title today-medium">
                    Detalle de pago
                  </h2>
                  <dl class="payment-list">
                    <div class="payment-list__row">
                      <dt>Monto total de financiación</dt>
                      <dd class="payment-list__value">
                        {{ formatCurrency(valueFinance) }}
                      </dd>
                    </div>
                    <div class="payment-list__row">
                      <dt>Número de cuotas</dt>
                      <dd>{{ feeNumber }} meses</dd>
                    </div>
                    <div class="payment-list__row">
                      <dt>Día de pago</dt>
                      <dd>
                        {{ new Date(valid.from).getDate() }} de cada mes
                      </dd>
                    </div>
                  </dl>
                </section>

                <section class="payment-amount">
                  <h2 class="payment-section__title today-medium">
                    Monto a pagar
                  </h2>
                  <p class="payment-amount__hint today-light">
                    Para activar tu póliza es necesario realizar el primer pago
                    de la cuota.
                  </p>

                  <currency-input
                    label="Monto a pagar"
                    :large="true"
                    :rules="[rules.min, rules.max]"
                    :options="{
                      locale: 'es-CO',
                      currency: 'COP',
                      currencyDisplay: 'symbol',
                      hideCurrencySymbolOnFocus: false,
                      hideGroupingSeparatorOnFocus: false,
                      hideNegligibleDecimalDigitsOnFocus: true,
                      autoDecimalDigits: false,
                      autoSign: true,
                      useGrouping: true,
                      accountingSign: false,
                    }"
                    v-model.number="otherAmount"
                    :disabled="false"
                    v-on:change="calculateFee($event)"
                  />

                  <v-btn
                    text
                    color="primary"
                    class="payment-plan-link today-medium"
                    :disabled="!payPlan.length"
                    @click="payDialog = true"
                  >
                    Ver plan de pagos
                  </v-btn>

                  <div class="payment-actions">
                    <v-btn
                      :disabled="!isValid || loadingCashPayment"
                      :loading="loadingCashPayment"
                      class="payment-btn payment-btn--secondary today-medium"
                      elevation="0"
                      @click.stop="paymentRequest('cash')"
                    >
                      Pago en efectivo
                    </v-btn>
                    <v-btn
                      :disabled="!isValid"
                      class="payment-btn payment-btn--primary today-medium"
                      elevation="0"
                      @click.stop="paymentRequest('pse')"
                    >
                      Pagar con PSE
                    </v-btn>
                  </div>
                </section>
              </v-col>
            </v-row>
          </template>
        </v-container>
        </div>
      </v-col>
    </v-row>

    <payment-plan
      :pay-plan="payPlan"
      :total-value-policy="valueFinance"
      :fee-number="feeNumber"
      :dialog="payDialog"
      @close="payDialog = false"
    />

    <v-dialog
      v-model="bankDialog"
      max-width="400"
      overlay-color="primary"
      content-class="payment-bank-dialog"
      :persistent="loadingPsePayment"
    >
      <v-card class="payment-bank-card">
        <v-card-title
          class="justify-center text-uppercase primary--text font-weight-bold today-medium payment-bank-card__title"
        >
          Selecciona tu banco
        </v-card-title>
        <div class="px-10 px-md-12 pb-7">
          <p class="payment-bank-card__hint today-light">
            Elige la entidad bancaria para continuar el pago con PSE.
          </p>
          <v-select
            v-model="bankId"
            :items="banks"
            item-text="name"
            item-value="code"
            :loading="loadingBanks || loadingPsePayment"
            :disabled="loadingBanks || loadingPsePayment"
            :rules="[rules.bank]"
            label="Banco"
            placeholder="Selecciona tu banco…"
            outlined
            dense
            color="primary"
            hide-details="auto"
            autocomplete="off"
          ></v-select>
          <v-btn
            block
            class="payment-bank-card__btn today-medium"
            elevation="0"
            :loading="loadingPsePayment"
            :disabled="!bankId || loadingBanks || loadingPsePayment"
            @click="generatePsePayment"
          >
            Continuar
          </v-btn>
          <p
            v-if="loadingPsePayment"
            class="payment-bank-card__status today-light"
            role="status"
          >
            Redirigiendo al pago…
          </p>
        </div>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="timeout" bottom right role="status">
      {{ messageSnackbar }}
    </v-snackbar>
  </div>
</template>

<script>
import LeftSideImage from "@/components/Layouts/LeftSideImage";
import NavBarPage from "@/components/Layouts/NavBarPage";
import { api } from "@/helpers/axios";
import {
  addDays,
  constants,
  formatCurrency,
  formatDecimal,
  formatDateCo,
} from "@/helpers/constants";
import { locals } from "@/helpers/locals";
import CurrencyInput from "@/components/CurrencyInput";
import PaymentPlan from "@/components/PaymentPlan.vue";

export default {
  name: "Payment",
  components: { PaymentPlan, LeftSideImage, NavBarPage, CurrencyInput },
  data() {
    return {
      dialog: false,
      pageLoading: true,
      loadingPsePayment: false,
      loadingCashPayment: false,
      loadingBanks: false,
      banks: [],
      bankId: "",
      bankDialog: false,
      expires_in: 60,
      countdown: "",
      minAmount: 0,
      urlPayment: "",
      otherAmount: "",
      snackbar: false,
      timeout: 4000,
      messageSnackbar: "",
      settings: null,
      request: null,
      insurer_name: null,
      valid: {
        from: false,
        to: false,
      },
      payDialog: false,
      payPlan: [],
      feeValue: 0,
      firstFeeValue: 0,
      creditStudy: 0,
      insurance: 0,
      creditInsurance: 0,
      ivaValue: 0,
      iva: 0,
      othersFeeValue: 0,
      amortizedFee: 0,
      admin: 0,
      totalValuePolicy: 0,
      discountValue: 0,
      valueFinance: 0,
      feeNumber: 2,
      insuranceRate: 0,
      rate: 0,
      rules: {
        min: () =>
          this.otherAmount >= this.minAmount ||
          "Este valor debe ser mayor que el pago mínimo" +
            " - " +
            this.formatCurrency(this.minAmount),
        max: () =>
          this.otherAmount <= this.valueFinance ||
          "Este valor no debe ser mayor que el valor de la poliza",
        bank: (v) => !!v || "Selecciona el banco para pagar con PSE",
      },
    };
  },
  computed: {
    isValid: function () {
      return (
        this.otherAmount >= this.minAmount &&
        this.otherAmount <= this.valueFinance
      );
    },
  },
  methods: {
    formatDateCo: formatDateCo,
    goHome() {
      this.dialog = false;
      this.$router.push("/");
    },
    newCalculateFee(valueFinance = null, discount = false) {
      this.payPlan = [];
      const date = new Date();
      const _date = `${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()}`;
      console.log(valueFinance, _date);
      api
        .post("https://tefio-vardi.bio.credit/calcularcuota", {
          data: {
            fecha: _date,
            valor: valueFinance ? valueFinance : this.valueFinance,
            plazo: discount ? this.feeNumber - 1 : this.feeNumber,
            tasa: this.insuranceRate,
            portafolio_id: 10040,
            idvardi: this.request.id,
          },
        })
        .then((response) => {
          const payPlan = response.data.plan_pagos;
          if (discount) {
            payPlan.unshift({
              nro_cuota: 0,
              cuota: this.otherAmount,
              saldo_final: this.valueFinance - this.otherAmount,
              abono_capital: this.otherAmount,
              interes_corriente: 0,
            });
          }

          this.payPlan = response.data.plan_pagos.map((item) => {
            item.cuota = formatDecimal(item.cuota);
            item.saldo_final = formatDecimal(item.saldo_final);
            item.abono_capital = formatDecimal(item.abono_capital);

            if (discount) {
              if (item.nro_cuota === 1) {
                item.interes_corriente = valueFinance * (this.rate / 100);
              }
              item.nro_cuota++;
            }
            return item;
          });
          this.payPlan.sort((a, b) => a.nro_cuota - b.nro_cuota);
        })
        .catch(
          function (error) {
            try {
              let status = error.response.status;
              if (status === 401) {
                locals.clearLocal();
                this.$router.push("/");
              }
              let errors = error.response.data.errors;
              let message = "";
              for (const [key, value] of Object.entries(errors)) {
                console.log(key + " : " + value);
                message = message + value + "<br>";
              }
              this.snackbarMessage = message;
              this.snackbar = true;
            } catch (e) {
              console.log(e);
            }
          }.bind(this)
        );
    },
    calculateFee(event) {
      let valueFinance = 0;
      if (this.otherAmount > this.minAmount) {
        valueFinance = this.valueFinance - this.otherAmount;
        this.newCalculateFee(valueFinance, true);
      }
    },
    formatCurrency: formatCurrency,
    showError(message) {
      this.snackbar = true;
      this.messageSnackbar = message || "Se ha producido un error";
    },
    backendErrorMessage(error, fallback) {
      const data = (error && error.response && error.response.data) || {};
      if (data.message) {
        return data.message;
      }
      if (data.errors && typeof data.errors === "object") {
        return Object.values(data.errors)
          .flat()
          .filter(Boolean)
          .join(" ");
      }
      return fallback || "Se ha producido un error";
    },
    loadBanks() {
      this.loadingBanks = true;
      api
        .get(constants.endPoints.paymentBanks, true)
        .then((response) => {
          const payload = response.data || {};
          if (payload.status === false) {
            this.banks = [];
            this.showError(
              payload.message || "No se pudo consultar la lista de bancos PSE"
            );
            return;
          }
          this.banks = (payload.data && payload.data.banks) || [];
          if (!this.banks.length) {
            this.showError("No hay bancos PSE disponibles en este momento");
          }
        })
        .catch((error) => {
          this.banks = [];
          this.showError(
            this.backendErrorMessage(
              error,
              "No se pudo consultar la lista de bancos PSE"
            )
          );
        })
        .finally(() => {
          this.loadingBanks = false;
        });
    },
    paymentRequest(source) {
      if (!this.isValid) {
        this.showError("Revisa el valor para continuar");
        return;
      }
      if (source === "pse") {
        this.openBankDialog();
        return;
      }
      this.generateCashPayment();
    },
    openBankDialog() {
      this.bankId = "";
      this.bankDialog = true;
      if (!this.banks.length && !this.loadingBanks) {
        this.loadBanks();
      }
    },
    generatePsePayment() {
      if (this.loadingPsePayment) {
        return;
      }
      if (!this.bankId) {
        this.showError("Selecciona el banco para pagar con PSE");
        return;
      }

      this.loadingPsePayment = true;
      const paymentType = this.otherAmount > this.minAmount ? "other" : "min";
      const body = {
        user_request_id: this.request.id,
        payment_type: paymentType,
        bank_id: String(this.bankId),
      };
      if (paymentType === "other") {
        body.other_amount = this.otherAmount;
      }

      api
        .post(constants.endPoints.paymentLink, body, true)
        .then((response) => {
          const payload = response.data || {};
          if (payload.status === false || !(payload.data && payload.data.payment_url)) {
            this.loadingPsePayment = false;
            this.showError(
              payload.message || "No se pudo generar la URL de pago PSE"
            );
            return;
          }
          this.urlPayment = payload.data.payment_url;
          window.location.assign(this.urlPayment);
        })
        .catch((error) => {
          this.loadingPsePayment = false;
          this.showError(
            this.backendErrorMessage(
              error,
              "No se pudo generar la URL de pago PSE"
            )
          );
        });
    },
    generateCashPayment() {
      this.loadingCashPayment = true;
      const date = addDays(new Date(), 1);
      api
        .post(
          constants.endPoints.paymentRequestCash,
          {
            user_request_id: this.request.id,
            route: "P",
            payment_limit: date.toISOString().slice(0, 10),
            max_pay: this.valueFinance,
            min_pay:
              this.otherAmount > this.minAmount
                ? this.otherAmount
                : (+this.minAmount).toFixed(0),
          },
          true
        )
        .then(
          ({ data }) => {
            localStorage.setItem("payment_reference", JSON.stringify(data));
            this.loadingCashPayment = false;
            this.$router.push("/cash-payment");
          },
          (error) => {
            console.log("paymentRequest", error);
            this.loadingCashPayment = false;
            this.snackbar = true;
            this.messageSnackbar = "Se ha producido un error";
          }
        );
    },
  },
  created: function () {
    this.settings = locals.getLocal("settings");
    this.request = locals.getLocal("request");
    api
      .post(
        constants.endPoints.startPayment,
        {
          user_request_id: this.request.id,
        },
        true
      )
      .then((response) => {
        let dataResponse = response.data.data;
        this.minAmount = dataResponse.min_payment;
        this.insurer_name = dataResponse.insurer_name;
        this.valid = dataResponse.valid;
        this.admin = parseInt(dataResponse.administration, 10);
        this.valueFinance = parseInt(dataResponse.total, 10);
        this.feeNumber = parseInt(dataResponse.fee_number, 10);
        this.insuranceRate = dataResponse.insurance_rate;
        this.rate = parseFloat(dataResponse.rate);
        this.iva = parseFloat(dataResponse.iva);
        this.creditInsurance = parseFloat(dataResponse.credit_insurance);
        this.creditStudy = parseInt(dataResponse.credit_study, 10);
        this.pageLoading = false;
        this.otherAmount = this.minAmount;
        this.newCalculateFee();
      })
      .catch(
        function (error) {
          try {
            let status = error.response.status;
            if (status == 401) {
              locals.clearLocal();
              this.$router.push("/");
            }
            let errors = error.response.data.errors;
            let message = "";
            for (var [key, value] of Object.entries(errors)) {
              console.log(key + " : " + value);
              message = message + value + "<br>";
            }
            this.snackbarMessage = message;
            this.snackbar = true;
          } catch (e) {
            console.log(e);
          }
        }.bind(this)
      );
  },
  watch: {
    otherAmount: function (value) {
      if (value === "min") {
        this.newCalculateFee();
        this.otherAmount = 0;
      }
    },
  },
};
</script>

<style lang="scss">
.payment-view {
  .payment-section {
    margin-bottom: 28px;
  }

  .payment-section__title {
    color: #00205b;
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    margin: 0 0 12px;
    text-wrap: balance;
  }

  .payment-list {
    margin: 0;
  }

  .payment-list__row {
    display: grid;
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    gap: 12px;
    align-items: baseline;
    padding: 10px 0;
    border-bottom: 1px solid #e8e8e8;

    &:last-child {
      border-bottom: none;
    }
  }

  .payment-list dt {
    color: rgba(0, 0, 0, 0.64);
    font-family: "HelveticaNeue-Light", "Roboto-Light", sans-serif;
    font-size: 0.875rem;
    min-width: 0;
  }

  .payment-list dd {
    color: #00205b;
    font-family: "HelveticaNeue-Medium", "Roboto-Medium", sans-serif;
    font-size: 0.875rem;
    margin: 0;
    min-width: 0;
    overflow-wrap: anywhere;
    text-align: right;
  }

  .payment-list__value {
    font-variant-numeric: tabular-nums;
  }

  .payment-amount {
    padding: 18px 18px 20px;
    border: 1px solid #e6e8ee;
    border-radius: 16px;
    background: #f8f9fc;
  }

  .payment-amount__hint {
    color: rgba(0, 0, 0, 0.64);
    font-size: 0.8125rem;
    line-height: 1.45;
    margin: 0 0 14px;
    text-wrap: pretty;
  }

  .payment-plan-link {
    display: inline-flex;
    min-height: 44px;
    margin: 4px 0 12px -8px;
    padding: 0 8px;
    letter-spacing: 0;
    text-transform: none !important;
    transition-property: opacity, color;
    transition-duration: 150ms;
    transition-timing-function: ease-out;
  }

  .payment-actions {
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .payment-btn {
    flex: 1 1 calc(50% - 6px);
    min-height: 44px;
    min-width: 0;
    height: 44px !important;
    border-radius: 10px !important;
    letter-spacing: 0 !important;
    text-transform: none !important;
    font-size: 0.9375rem !important;
    touch-action: manipulation;
    transition-property: transform, background-color, color, box-shadow, border-color, opacity;
    transition-duration: 150ms;
    transition-timing-function: ease-out;
  }

  .payment-btn:active:not(.v-btn--disabled) {
    transform: scale(0.96);
  }

  .payment-btn--primary {
    background: #00205b !important;
    color: #ffffff !important;
    box-shadow: 0 1px 2px rgba(0, 32, 91, 0.18), 0 6px 16px rgba(0, 32, 91, 0.12);
  }

  .payment-btn--primary:hover:not(.v-btn--disabled) {
    background: #001846 !important;
  }

  .payment-btn--secondary {
    background: #ffffff !important;
    color: #00205b !important;
    border: 1px solid #cfd5e4 !important;
  }

  .payment-btn--secondary:hover:not(.v-btn--disabled) {
    background: #eef1f7 !important;
    border-color: #00205b !important;
  }

  .payment-btn.v-btn--disabled {
    opacity: 0.5;
  }

  .payment-btn:focus-visible {
    outline: 2px solid #00205b;
    outline-offset: 3px;
  }

  .v-input input {
    height: 45px !important;
    max-height: 45px !important;
    font-size: 18px !important;
    font-variant-numeric: tabular-nums;
  }
}

.payment-bank-dialog {
  overflow: hidden;
  overscroll-behavior: contain;
  border-radius: 20px !important;
}

.payment-bank-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.payment-bank-card__title {
  padding-top: 32px !important;
  text-wrap: balance;
}

.payment-bank-card__hint {
  color: rgba(0, 0, 0, 0.64);
  font-size: 0.875rem;
  line-height: 1.45;
  margin: 0 0 20px;
  text-align: center;
  text-wrap: pretty;
}

.payment-bank-card__btn {
  background: #00205b !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 2px rgba(0, 32, 91, 0.18), 0 6px 16px rgba(0, 32, 91, 0.12);
  color: #ffffff !important;
  font-size: 0.9375rem !important;
  height: 44px !important;
  letter-spacing: 0 !important;
  margin-top: 20px;
  min-height: 44px;
  text-transform: none !important;
  touch-action: manipulation;
  transition-duration: 150ms;
  transition-property: transform, background-color, box-shadow, opacity;
  transition-timing-function: ease-out;
}

.payment-bank-card__btn:hover:not(.v-btn--disabled) {
  background: #001846 !important;
}

.payment-bank-card__btn:active:not(.v-btn--disabled) {
  transform: scale(0.96);
}

.payment-bank-card__btn.v-btn--disabled {
  opacity: 0.5;
}

.payment-bank-card__btn:focus-visible {
  outline: 2px solid #00205b;
  outline-offset: 3px;
}

.payment-bank-card__status {
  color: #00205b;
  font-size: 0.8125rem;
  line-height: 1.4;
  margin: 16px 0 0;
  text-align: center;
}

@media (prefers-reduced-motion: reduce) {
  .payment-view .payment-btn,
  .payment-bank-card__btn {
    transition: none;
  }

  .payment-view .payment-btn:active:not(.v-btn--disabled),
  .payment-bank-card__btn:active:not(.v-btn--disabled) {
    transform: none;
  }
}

.v-stepper__label {
  font-size: 13px;
}

.active-step .v-stepper__label {
  color: #00205b !important;
}

.active-step > span {
  min-width: 12px !important;
  height: 12px !important;
  width: 12px !important;
  background: #00205b !important;
}

.grey-step > span {
  min-width: 12px !important;
  height: 12px !important;
  width: 12px !important;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin-top: 29px !important;
}

.active-separator-step {
  border-color: #00205b !important;
}

.grey-separator-step {
  border-color: rgba(0, 0, 0, 0.38) !important;
}

.v-divider {
  border-width: 1px 2px 2px !important;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 29px -82px 0 !important;
}

@media (max-width: 600px) {
  .payment-view .payment-list__row {
    grid-template-columns: 1fr;
    gap: 2px;
  }

  .payment-view .payment-list dd {
    text-align: left;
  }

  .payment-view .payment-amount {
    margin-bottom: 8px;
    padding: 16px 16px 24px;
    border-radius: 14px;
  }

  .payment-view .payment-actions {
    flex-direction: column;
  }

  .payment-view .payment-btn {
    flex: 1 1 auto;
    max-width: 100%;
    width: 100%;
  }

  .v-stepper--alt-labels .v-stepper__step {
    flex-basis: 120px !important;
    padding: 5px !important;
  }

  .v-divider {
    visibility: hidden;
  }
}
</style>
